import React from 'react'; // We can simplify this import as the hooks are no longer here

// --- IMPORT THE NEW COMPONENT ---
import AnimateOnScroll from '../AnimateOnScroll/AnimateOnScroll';
// --- 1. LOCAL IMAGE IMPORTS (UPDATED FOR INTERIOR DESIGN) ---
import InteriorImage1 from '../../../assets/Images/PillarImage1.png';
import InteriorImage2 from '../../../assets/Images/PillarImage2.png';
import InteriorImage3 from '../../../assets/Images/PillarImage3.png';
import InteriorImage4 from '../../../assets/Images/PillarImage4.png';
import InteriorImage5 from '../../../assets/Images/PillarImage5.png'; 

// --- AnimateOnScroll Component was removed from here ---

const OurValues = () => {
    return (
        // BACKGROUND: Converted to Black/Red/White theme (using light gray/white)
        <section id="our-values" className="py-24 bg-gray-50 text-gray-800">
            <style>{`
                /* Custom styles for Red/Black/White theme */
                .text-gradient-red-black {
                    background-image: linear-gradient(to right, #DC2626, #1F2937); /* Red and Dark Gray/Black */
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }
                .bg-brand-red { background-color: #DC2626; }
            `}</style>
            <div className="container mx-auto px-6">
                <AnimateOnScroll direction="up">
                    <div className="text-center mb-16">
                        <h2 className="text-4xl md:text-5xl headline-font text-gradient-red-black">The Pillars of Our Design Studio</h2>
                        <p className="text-xl mt-4 max-w-2xl mx-auto">Our work is defined by an unwavering commitment to quality, function, and the seamless realization of your unique vision.</p>
                    </div>
                </AnimateOnScroll>
                
                {/* --- Pillar 1: Uncompromising Quality & Materials --- */}
                <div className="grid md:grid-cols-2 gap-16 items-center mb-16">
                    <AnimateOnScroll direction="right">
                        {/* Image: Interior 1 */}
                        <img src={InteriorImage1} className="w-full h-96 object-cover rounded-xl shadow-2xl" alt="Close-up of premium interior materials like wood and stone" />
                    </AnimateOnScroll>
                    <AnimateOnScroll direction="left">
                        <h3 className="text-3xl headline-font text-gradient-red-black">Uncompromising Quality & Materials</h3>
                        <p className="mt-4 text-lg">We specify and source only premium, commercial grade materials. Our focus is on long term value, using durable hardwoods, high density cabinetry, and archival finishes. From the structural elements to the final textile, every component is chosen for its longevity and aesthetic perfection, ensuring your space maintains its integrity for decades.</p>
                    </AnimateOnScroll>
                </div>

                {/* --- Pillar 2: Hand-Crafted Authenticity & Custom Work --- */}
                <div className="grid md:grid-cols-2 gap-16 items-center mb-16">
                    <AnimateOnScroll direction="right" className="order-last md:order-first">
                        <h3 className="text-3xl headline-font text-gradient-red-black">Bespoke, Custom Craftsmanship</h3>
                        <p className="mt-4 text-lg">We stand against generic, off the shelf solutions. Every project features bespoke elements custom millwork, unique built ins, and tailor made furniture designed specifically for your space. This dedication to hand crafted authenticity ensures your interior is truly one of a kind and optimized for your lifestyle.</p>
                    </AnimateOnScroll>
                    <AnimateOnScroll direction="left">
                        {/* Image: Interior 2 */}
                        <img src={InteriorImage2} className="w-full h-96 object-cover rounded-xl shadow-2xl" alt="Detail of custom designed kitchen cabinetry" />
                    </AnimateOnScroll>
                </div>

                {/* --- Pillar 3: Clarity of Vision & Communication --- */}
                <div className="grid md:grid-cols-2 gap-16 items-center mb-16">
                    <AnimateOnScroll direction="right">
                        {/* Image: Interior 3 */}
                        <img src={InteriorImage3} className="w-full h-96 object-cover rounded-xl shadow-2xl" alt="3D rendering meeting showing clear planning" />
                    </AnimateOnScroll>
                    <AnimateOnScroll direction="left">
                        <h3 className="text-3xl headline-font text-gradient-red-black">The Clarity of Your Vision</h3>
                        <p className="mt-4 text-lg">We prioritize precise collaboration from day one. Using photorealistic 3D visualization and meticulous floor plans, we ensure you see and approve the entire design before any physical work begins. This process eliminates guesswork and guarantees that your cherished vision is realized with absolute perfection.</p>
                    </AnimateOnScroll>
                </div>

                {/* --- Pillar 4: Capturing the Intangible (Mood & Ambiance) --- */}
                <div className="grid md:grid-cols-2 gap-16 items-center mb-16">
                    <AnimateOnScroll direction="right" className="order-last md:order-first">
                        <h3 className="text-3xl headline-font text-gradient-red-black">Atmospheric Mood & Ambiance</h3>
                        <p className="mt-4 text-lg">Interior design is the art of preserved feeling. We delve deeper than aesthetics to capture the intangible mood and ambiance you desire whether it's quiet serenity, vibrant energy, or sophisticated warmth. Through expert layering of lighting, materials, and color, we translate your ideal atmosphere vividly into a physical space.</p>
                    </AnimateOnScroll>
                    <AnimateOnScroll direction="left">
                        {/* Image: Interior 4 */}
                        <img src={InteriorImage4} className="w-full h-96 object-cover rounded-xl shadow-2xl" alt="Interior space with warm, layered lighting" />
                    </AnimateOnScroll>
                </div>
                
                {/* --- Pillar 5: A Cherished Legacy (Timeless Design) --- */}
                <div className="grid md:grid-cols-2 gap-16 items-center">
                    <AnimateOnScroll direction="right">
                        {/* Image: Interior 5 */}
                        <img src={InteriorImage5} className="w-full h-96 object-cover rounded-xl shadow-2xl" alt="Timeless, elegant living space" />
                    </AnimateOnScroll>
                    <AnimateOnScroll direction="left">
                        <h3 className="text-3xl headline-font text-gradient-red-black">Enduring Design Legacy</h3>
                        <p className="mt-4 text-lg">We create enduring spaces that transcend fleeting trends. Our designs are timeless and elegant, built to function and delight for decades. We craft your space not just for today, but as a valuable and beautiful legacy of comfort, style, and lasting quality for your family or business.</p>
                    </AnimateOnScroll>
                </div>

            </div>
        </section>
    );
};

export default OurValues;